import { apiMain } from './config/axios';
import { store } from '../store';

export const signIn = (data) => apiMain.post('/api/v1/user/login', data);
export const sendAuthOtp = (data) => apiMain.post('/api/v1/user/send-auth-otp', data);
export const verifyAuthOtp = (data) => apiMain.post('/api/v1/user/verify-auth-otp', data);
export const googleSignIn = (data) => apiMain.post('/api/v1/user/social-auth', data);
export const verifyResetOtp = (data) => apiMain.post('/api/v1/user/verify-reset-otp', data);
export const resetPassword = (data) => apiMain.post('/api/v1/user/reset-password', data);

export const getUser = (token = '') => {
  const savedToken = store.getState().auth.token;
  return apiMain.get('/api/v1/user/me', {}, { headers: { Authorization: `Bearer ${token || savedToken}` } });
};
